export const setupProgressBar = (emblaApi, progressNode) => {
    const barNode = progressNode.querySelector('.embla__progress__bar');

    const applyProgress = () => {
        const progress = Math.max(0, Math.min(1, emblaApi.scrollProgress()));
        barNode.style.transform = `translateX(${progress * 100}%)`;
    };

    emblaApi.on('scroll', applyProgress);
    // Aplica o progresso na inicialização
    applyProgress();
};